import React from "react";
import classes from "./ScratchList.module.scss";
import routeCafImage from "../../assets/ScratchImages/EnRoutePourLaCaf.jpg";
import bingoAlphabe from "../../assets/ScratchImages/bingoAlphabet.png";
import tourneDechance from "../../assets/ScratchImages/tourneDechance.png";
import lucky7 from "../../assets/ScratchImages/lucky7.png";
import bingoSafary from "../../assets/ScratchImages/bingoSafary.png";
import sportdechance from "../../assets/ScratchImages/sportdechance.png";
import fruitsdechance from "../../assets/ScratchImages/fruitsdechance.png";
import doubleMillionaire from "../../assets/ScratchImages/doubleMillionaire.png";
import cardsImage from "../../assets/MainBannerImages/Cards.png";
import ourScratch from "../../assets/MainBannerImages/scratchtext.png";
import scratchAndWin from "../../assets/MainBannerImages/ScratchandWin.png";
import routeCafLogo from "../../assets/ScratchImages/Caf-mainLogo.png";
import bingoActiveLogo from "../../assets/ScratchImages/bingoActiveLogo.png";
import tournedechanceLogo from "../../assets/ScratchImages/tournedechanceLogo.png";
import lucky7logo from "../../assets/ScratchImages/lucky7-logo.png";
import bingosafari from "../../assets/ScratchImages/bingo-safari.png";
import sportdechanceLogo from "../../assets/ScratchImages/new-sport-logo.png";
import newfruitlogo from "../../assets/ScratchImages/new-fruit-logo.png";
import DMLogo from "../../assets/ScratchImages/DMLogo.png";
import warningIcon from "../../assets/ScratchImages/warning.svg"
import { useNavigate } from "react-router";
import Footer from "../Footer/Footer";
import Header from "../Header/Header";

function ScratchList() {
    const navigate = useNavigate();

    const scratchItems = [
        { src: routeCafLogo, alt: "Yupi Scratch Game", background: routeCafImage, className: classes.yupi, route: "/caf" },
        { src: bingoActiveLogo, alt: "Bingo Alphabet Scratch Game", background: bingoAlphabe, className: classes.bingoAlphabet, route: "/bingo-alphabet" },
        { src: tournedechanceLogo, alt: "Tourne De Chance Scratch Game", background: tourneDechance, className: classes.tourneDeChance, route: "/tourne-de-chance" },
        { src: lucky7logo, alt: "Lucky 7 Scratch Game", background: lucky7, className: classes.lucky7, route: "/lucky7" },
        { src: bingosafari, alt: "Bingo Safari Scratch Game", background: bingoSafary, className: classes.bingoSafary, route: "/bingo-safari" },
        { src: sportdechanceLogo, alt: "Sport De Chance Scratch Game", background: sportdechance, className: classes.sportDeChance, route: "/sport-de-Chance" },
        { src: newfruitlogo, alt: "Fruits De Chance Scratch Game", background: fruitsdechance, className: classes.fruitsDeChance, route: "/fruit-de chance" },
        { src: DMLogo, alt: "Double Millionaire Scratch Game", background: doubleMillionaire, className: classes.doubleMillionaire, route: "/double-millionaire" }
    ];

    return (
        <>
            <Header />
            <div className={classes.scratchListCont}>
                <div className={classes.scratchListBack}>
                    <img src={cardsImage} alt="cards logo" className={classes.cardsStyle} />
                    <img src={ourScratch} alt="our scratch logo" className={classes.ourScratchStyle} />
                    <img src={scratchAndWin} alt="scratchAndWin logo" className={classes.scratchAndWinStyle} />
                </div>

                <div className="container">
                    <div className={classes.backhomePage}>
                        <span className="titleBack" onClick={() => navigate('/')}>Back to Homepage</span>
                    </div>
                    <div className={classes.listScratchGames}>
                        {scratchItems.map((item, index) => (
                            <div
                                key={index}
                                className={`${classes.scratchItem}`}
                                style={{
                                    backgroundImage: `url(${item.background})`,
                                    cursor: "pointer"
                                }}
                                onClick={() => navigate(item.route)}
                            >
                                <img
                                    src={item.src}
                                    alt={item.alt}
                                    className={`${classes.scratchContStyle} ${item.className}`}
                                />
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            <div className={classes.requestStyle}>
                <img src={warningIcon} alt="warning Icon" className={classes.iconStyle} />
                <span className={classes.requestText}>All Games can be customised upon request</span>
            </div>
            <Footer changeColor="white" iconsColor="black" />
        </>
    );
}

export default ScratchList;
